// extracted by mini-css-extract-plugin
export default {"promoSlot":"styles-module__promoSlot___83FHJ","deal":"styles-module__deal___DBM5K"};